import script from "./TreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeItem.vue?vue&type=script&setup=true&lang=js"

import "./TreeItem.vue?vue&type=style&index=0&id=1be1d532&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be1d532"]])

export default __exports__